var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.295 0.692656L13.3075 1.70516C13.9 2.29016 13.9 3.24266 13.3075 3.82766L3.385 13.7502H0.25V10.6152L8.05 2.80766L10.1725 0.692656C10.7575 0.107656 11.71 0.107656 12.295 0.692656ZM1.75 12.2502L2.8075 12.2952L10.1725 4.92266L9.115 3.86516L1.75 11.2302V12.2502Z",
    fill: "#2A4153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e2e39d84fe8819bc2f85b9e0a01e4d76.svg";
export { ForwardRef as ReactComponent };